module.exports = __webpack_public_path__ + "static/img/Kolkata.31dfe9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Kolkata.png
// module id = drh8
// module chunks = 11